/**
 * Message lisible d'une erreur levée par model-core (le « detail » API Platform, ex. « plainPassword: Cette chaîne est trop courte… »).
 * Les préfixes de propriété sont retirés ; une erreur sans message (réseau…) donne le message par défaut.
 */
export function getApiErrorMessage(error: unknown, fallback = 'Une erreur est survenue, veuillez réessayer.'): string {
  if (typeof error !== 'string' || !error.trim()) return fallback;

  return subRequestDetail(error)
    .split('\n')
    .map((line) => line.replace(/^[\w.[\]]+:\s*/, '').trim())
    .filter(Boolean)
    .join('\n');
}

/** Suppression en lot refusée : le « detail » est la réponse JSON de la sous-requête en échec, on en garde le sien */
function subRequestDetail(error: string): string {
  if (!error.startsWith('{')) return error;
  try {
    const detail = (JSON.parse(error) as { detail?: unknown }).detail;
    return typeof detail === 'string' && detail.trim() ? detail : error;
  } catch {
    return error;
  }
}
